import * as v from 'valibot';

import { simpleStatisticsSchema } from '#entities';

export const simpleStatisticsResponseSchema = v.object({
  /** Array of active cases */
  data: simpleStatisticsSchema,
  /** Timestamp when the report was generated (ISO 8601) */
  dataGeneratedAt: v.string(),
  errors: v.nullable(v.array(v.unknown())),
  expires: v.nullable(v.string()),
  errorsGeneratedAt: v.nullable(v.string()),
});

export type SimpleStatisticsResponse = v.InferInput<
  typeof simpleStatisticsResponseSchema
>;
